const en = {
  title: 'Recording analysis', empty: 'Open a recording from Counter to check its analysis.',
  invalid: 'The recording link is invalid. Open it again from Counter.',
  loading: 'Checking the current analysis…', error: 'The current result could not be loaded. Refresh or ask staff for help.',
  missing: 'This server does not provide analysis status yet.', pending: 'No analysis result is available for this recording yet.',
  stale: 'This result does not match the current recording. Ask staff to check it.',
  complete: 'Analysis completed', unavailable: 'Analysis unavailable', failed: 'Analysis could not finish',
  separate: 'Analysis completion does not approve footage or determine payment.',
  episode: 'Episode', ingest: 'Delivery', assessment: 'Assessment', reason: 'Technical reason', refresh: 'Refresh result',
};
const vi: typeof en = {
  title: 'Phân tích bản ghi', empty: 'Mở bản ghi từ Quầy tiếp nhận để xem trạng thái phân tích.',
  invalid: 'Liên kết bản ghi không hợp lệ. Hãy mở lại từ Quầy tiếp nhận.',
  loading: 'Đang kiểm tra kết quả mới nhất…', error: 'Chưa tải được kết quả hiện tại. Hãy tải lại hoặc nhờ nhân viên kiểm tra.',
  missing: 'Máy chủ chưa hỗ trợ xem trạng thái phân tích.', pending: 'Bản ghi này chưa có kết quả phân tích.',
  stale: 'Kết quả này không còn khớp với bản ghi hiện tại. Nhờ nhân viên kiểm tra lại.',
  complete: 'Đã phân tích xong', unavailable: 'Chưa thể phân tích', failed: 'Phân tích không thành công',
  separate: 'Phân tích xong không có nghĩa là bản ghi đã được duyệt hoặc được tính tiền.',
  episode: 'Mã bản ghi', ingest: 'Mã lần gửi', assessment: 'Mã kết quả', reason: 'Lý do kỹ thuật', refresh: 'Tải lại kết quả',
};
const zh: typeof en = {
  title: '录像分析', empty: '请从接收台打开录像以查看分析状态。',
  invalid: '录像链接无效，请从接收台重新打开。',
  loading: '正在检查当前分析结果…', error: '无法加载当前结果，请刷新或联系工作人员。',
  missing: '此服务器暂不提供分析状态。', pending: '此录像尚无分析结果。',
  stale: '此结果与当前录像不符，请工作人员检查。',
  complete: '分析已完成', unavailable: '无法分析', failed: '分析未能完成',
  separate: '完成分析并不表示录像获批或确定付款。',
  episode: '录像', ingest: '提交', assessment: '分析结果', reason: '技术原因', refresh: '刷新结果',
};
export const pipelineOriginalityCopy = (language: string) => language.startsWith('vi') ? vi : language.startsWith('zh') ? zh : en;
